import Vue from 'vue'
import Router from 'vue-router'

const BottomNav = () => import('@/components/user/bottomNav');
const MemberLine = () => import('@/components/shop/memberEntryLINE');
const MemberFB = () => import('@/components/shop/memberEntryFB');
const Member = () => import('@/components/shop/memberEntry');
const RegisterNew = () => import('@/components/user/registerNew');
const Success = () => import('@/components/success');

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Success,
    },
    {
      path: '/FB',
      name: 'FB',
      component: RegisterNew,
    },
    {
      path: '/LINE',
      name: 'LINE',
      component: RegisterNew,
    },
    {
      path: '/memberpage/:service/:auth',
      name: 'memberpage',
      component: BottomNav,
    },
    {
      path: '/memberPremium',
      name: 'memberPremium',
      component: Member,
    },
    {
      path: '/memberLine',
      name: 'memberLine',
      component: MemberLine,
    },
    {
      path: '/memberFB',
      name: 'memberFB',
      component: MemberFB,
    }
  ]
})

export default router;